<template>
  <div class="card" :class="{ active: menuFocused }">
    <div>
      <template v-if="layout == 'home'">
        <header>
          <h1>{{ labels.SEN_GUIDA_TITLE_LABEL }}</h1>
          <h2 class="h1">{{ labels.SEN_GUIDA_TOPIC_LABEL }}</h2>
          <p class="cta">{{ labels.SEN_GUIDA_TOPIC_CTA }}</p>
        </header>
      </template>

      <template v-if="layout == 'extended'">
        <h1 class="title" tabindex="-1" ref="topicTitle">{{ content.label }}</h1>
        <p v-html="content.description"></p>
        <p class="cta" v-if="content[nextLevel]">{{ labels.SEN_GUIDA_TOPIC_CTA }}</p>
      </template>

      <nav v-if="content[nextLevel]" :aria-label="navLabel">
        <span class="hidden">{{ navLabel }}</span>
        <ul>
          <li
            v-for="(content, slug) in content[nextLevel]"
            :key="content.label"
            :class="{ active: isActive(nextLevel, slug) }"
          >
            <router-link
              :to="{ query: { ...queryBuilder, [nextLevel]: slug } }"
              @focus.native="isMenuFocused = true"
              @blur.native="isMenuFocused = false"
            >
              {{ content.label }}
              <span class="visuallyhidden" v-if="isActive(nextLevel, slug)">
                selezionato</span
              >
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <template v-if="layout == 'extended'">
      <SurroundingLinks />
    </template>
  </div>
</template>

<script>
import contentBuilder from "@/mixins/contentBuilder";
import labels from "@/data/labels.json";

import SurroundingLinks from "./SurroundingLinks.vue";
export default {
  props: {
    level: Number,
    layout: {
      validator(value) {
        // The value must match one of these strings
        return ["home", "extended", "navigation"].includes(value);
      },
    },
  },
  computed: {
    navLabel: function () {
      switch (this.level) {
        case 0:
          return labels.SEN_GUIDA_MENU_CATEGORIES_LABEL;
        case 1:
          return labels.SEN_GUIDA_MENU_LEVEL1_LABEL;
        case 2:
          return labels.SEN_GUIDA_MENU_LEVEL2_LABEL;
        case 3:
          return labels.SEN_GUIDA_MENU_LEVEL3_LABEL;
      }
      return "";
    },
  },
  data() {
    return {
      labels,
      isMenuFocused: false,
      menuFocused: false,
    };
  },
  methods: {
    isActive: function (nextLevel, slug) {
      return this.$route.query[nextLevel] == slug ? true : false;
    },
  },
  watch: {
    isMenuFocused: function () {
      setTimeout(() => {
        this.menuFocused = this.isMenuFocused;
      }, 10);
    },
    // focusing topic title on route change
    $route: function() {
      if (this.$refs.topicTitle) {
        this.$nextTick(() => {
          this.$refs.topicTitle.focus();
        });
      }
    }
  },
  mixins: [contentBuilder],
  components: { SurroundingLinks },
};
</script>
<style lang="scss" scoped></style>
